document.addEventListener("DOMContentLoaded", () => {

  //article main filter
    let dropdown = document.querySelector('.blog_news_option select');
    if (dropdown) {
        dropdown.addEventListener("change", (event) => {
            let selectedValue = event.target.value;
            window.location.href = selectedValue;
        });
    }

  //article report filter
    let dropdown_report = document.querySelector('.report_selector');
    if (dropdown_report) {
        dropdown_report.addEventListener("change", (event) => {
            let selectedValue_re = event.target.value;
            let currentUrl = window.location.href;
            let baseUrl = currentUrl.split('/tagged/')[0];
            if (selectedValue_re.includes("report_")) {
                var newUrl = baseUrl + '/tagged/' + encodeURIComponent(selectedValue_re);
            } else {
                var newUrl = baseUrl;
            }
            window.location.href = newUrl;
        });
    }




    document.querySelectorAll('.selling-plan-group ul li').forEach((item) => {
        item.addEventListener('click', () => {
            const parent = item.closest('.product_form_btn');
            parent.querySelectorAll('.selling-plan-group ul li').forEach((li) =>
                li.classList.remove('active')
            );
            item.classList.add('active');
        });
    });

    document.querySelectorAll('.btn_adop_product span').forEach((item) => {
        item.addEventListener('click', () => {
            const parent = item.closest('.product_form_btn');
            const variantId = parent.querySelector('.selling-plan-group ul li.active').getAttribute('data-variantid');
            const variantName = parent.querySelector('.selling-plan-group ul li.active').getAttribute('data-title');
            // const VarNameSplit = variantName.split(" - ");
            if (variantName == 'One Time Contribution') {
                AddToCart(variantId, 1, '');
            } else {
                const sellingPlan_ID = parent.querySelector('.selling-plan-group-id ul li[data-name="' + variantName + '"]').getAttribute('data-id');
                AddToCart(variantId, 1, sellingPlan_ID);
            }
        });
    });

    function AddToCart(variantId, quantity = 1, sellingPlanId = null) {
        const randomID = Math.floor(Math.random() * 1e6);
        const data = {
            id: variantId,
            quantity: quantity,
            properties: {
                "Support Id": randomID
            }
        };

        if (sellingPlanId) {
            data.selling_plan = sellingPlanId;
        }

        fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not OK');
                }
                return response.json();
            })
            .then(data => {
                window.location.href = '/cart';
            })
    }

    const urlElements = document.querySelectorAll('#product-urls span');
    if (urlElements) {
        const productUrls = Array.from(urlElements).map(span => span.textContent.trim());
        const randomUrl = productUrls[Math.floor(Math.random() * productUrls.length)];
        console.log('test--' + randomUrl);
        const update_url = document.querySelector('.link_coll_btn');
        if (update_url) {
            update_url.setAttribute('href', randomUrl);
        }
    }


    // Project page tab & data get to ajax
    var tabs = document.querySelectorAll('.project-content-top .tab-item');
    if (tabs) {
        tabs.forEach((item) => {
            item.addEventListener('click', () => {
                var tab_title = document.querySelectorAll('.project-content-top .tab-item');
                tab_title.forEach(tabtitle => tabtitle.classList.remove('tab_active'));
                item.classList.add('tab_active');
                var value = item.dataset.value;
                var url = item.dataset.handle;
                var tabs_content = document.querySelectorAll('.tab-content-main .tab-content-item');
                tabs_content.forEach(tab => tab.classList.remove('active'));
                document.querySelector('.tab-content-main .tab-content-item[tab-item="' + value + '"]').classList.add('active');

                let data_check = document.querySelector('.tab-content-main .tab-content-item.active').innerHTML;
                data_check = data_check.trim();
                // alert(data_check);
                if (data_check == "") {
                    fetch(url, {
                            method: 'GET',
                            mode: 'cors'
                        })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok ' + response.statusText);
                            }
                            return response.text();
                        })

                        .then(data => {
                            // console.log(data);
                            let parser = new DOMParser();
                            let doc = parser.parseFromString(data, 'text/html');
                            let html_data = doc.querySelector('#MainContent').innerHTML;
                            // console.log(html_data);
                            if (html_data) {
                                document.querySelector('.temp-spx-Projects .tab-content-main .tab-content-item.active').innerHTML = html_data;
                            } else {
                                console.error("Element #MainContent not found in the response data.");
                            }
                        });
                }
            });
        });
    }

    // onload page data get
    var tabs = document.querySelector('.project-content-top .tab-item:first-child');
    if (tabs) {
        var url = tabs.dataset.handle;
        fetch(url, {
                method: 'GET',
                mode: 'cors'
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.text();
            })
            .then(data => {
                // console.log(data);
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, 'text/html');
                let html_data = doc.querySelector('#MainContent').innerHTML;
                console.log(html_data);
                if (html_data) {
                    document.querySelector('.temp-spx-Projects .tab-content-main .tab-content-item.active').innerHTML = html_data;
                } else {
                    console.error("Element #MainContent not found in the response data.");
                }
            });
    }


    let monthly_donations = document.querySelector('.monhtly_donations');
    if (monthly_donations) {
        monthly_donations.addEventListener('click', function(event) {
            event.preventDefault();
            let enteramount = document.querySelector('.enter_amount_box input');
            if (enteramount) {
                let amountValue = enteramount.value;
                if (amountValue > 0 && amountValue != '') {
                    document.querySelector('.pre_loader').style.display = 'block';
                    const formData = new FormData();
                    formData.append('Price', amountValue);
                    fetch('https://dev.shopifyexperthelp.com/app/mamaibado/stripe.php', {
                        method: 'POST',
                        body: formData,
                    }).then(response => {
                        if (!response.ok) {}
                        return response.text();
                    }).then(response => {
                        let url = response;
                        document.querySelector('.pre_loader').style.display = 'none';
                        if (url) {
                            window.location.href = url;
                        }
                    })

                }
            }
        });
    }


      const slider_multi = document.querySelector(".multi_col_slider");
    if (slider_multi) {
        const trackmulti = slider_multi.querySelector(".multi_col_slider .multicolumn-list");
        const prevmulti = slider_multi.querySelector(".slider-button--prev");
        const nextmulti = slider_multi.querySelector(".slider-button--next");

        if (trackmulti) {
            prevmulti.addEventListener("click", () => {
                nextmulti.removeAttribute("disabled");

                trackmulti.scrollTo({
                    left: trackmulti.scrollLeft - trackmulti.firstElementChild.offsetWidth,
                    behavior: "smooth"
                });
            });

            nextmulti.addEventListener("click", () => {
                prevmulti.removeAttribute("disabled");

                trackmulti.scrollTo({
                    left: trackmulti.scrollLeft + trackmulti.firstElementChild.offsetWidth,
                    behavior: "smooth"
                });
            });

            trackmulti.addEventListener("scroll", () => {
                const trackScrollWidth = trackmulti.scrollWidth;
                const trackOuterWidth = trackmulti.clientWidth;

                prevmulti.removeAttribute("disabled");
                nextmulti.removeAttribute("disabled");

                if (trackmulti.scrollLeft <= 0) {
                    prevmulti.setAttribute("disabled", "");
                }

                if (trackmulti.scrollLeft === trackScrollWidth - trackOuterWidth) {
                    nextmulti.setAttribute("disabled", "");
                }
            });
        }
    }

//slider
    const slider = document.querySelector(".slider_custom[data-slider]");
    if (slider) {
        const track = slider.querySelector(".image_icon_content_main");
        const prev = slider.querySelector("[data-slider-prev]");
        const next = slider.querySelector("[data-slider-next]");

        if (track) {
            prev.addEventListener("click", () => {
                next.removeAttribute("disabled");

                track.scrollTo({
                    left: track.scrollLeft - track.firstElementChild.offsetWidth,
                    behavior: "smooth"
                });
            });

            next.addEventListener("click", () => {
                prev.removeAttribute("disabled");

                track.scrollTo({
                    left: track.scrollLeft + track.firstElementChild.offsetWidth,
                    behavior: "smooth"
                });
            });

            track.addEventListener("scroll", () => {
                const trackScrollWidth = track.scrollWidth;
                const trackOuterWidth = track.clientWidth;

                prev.removeAttribute("disabled");
                next.removeAttribute("disabled");

                if (track.scrollLeft <= 0) {
                    prev.setAttribute("disabled", "");
                }

                if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
                    next.setAttribute("disabled", "");
                }
            });
        }
    }

  var file_data_upload = document.querySelector('#file-upload');
  
  if (file_data_upload) {
    
      file_data_upload.addEventListener('change', function() {
      var fileInput = document.getElementById('file-upload');
      var resumeInput = document.getElementById('file-upload-resume');
      var formData = new FormData();
      formData.append('file', fileInput.files[0]); 

        document.querySelector('#ContactForm button[type="submit"]').setAttribute('disabled', 'disabled');
        
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://dev.shopifyexperthelp.com/app/mamaibado/fileupload.php', true);
      xhr.onload = function(data) {
          if (xhr.status === 200) {
               var response = JSON.parse(xhr.responseText);          
            document.querySelector('#uploaded_volunteer_application').value = response;
            document.querySelector('#ContactForm button[type="submit"]').removeAttribute('disabled');

          } else {
              //alert('Error uploading files!');
            document.querySelector('#ContactForm button[type="submit"]').removeAttribute('disabled', 'disabled');

          }
      };
      xhr.send(formData);
    });

    document.querySelector('#file-upload-resume').addEventListener('change', function() {
      var resumeInput = document.getElementById('file-upload-resume');
      var formData = new FormData();
      formData.append('file', resumeInput.files[0]); 
      document.querySelector('#ContactForm button[type="submit"]').setAttribute('disabled', 'disabled');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://dev.shopifyexperthelp.com/app/mamaibado/fileupload.php', true);
      xhr.onload = function(data) {
          if (xhr.status === 200) {
          var response = JSON.parse(xhr.responseText);
          document.querySelector('#uploaded_resume').value = response;  
            document.querySelector('#ContactForm button[type="submit"]').removeAttribute('disabled');
          } else {
            document.querySelector('#ContactForm button[type="submit"]').removeAttribute('disabled', 'disabled');
          }
      };
      xhr.send(formData);
    });
    
  }


const donateBtns = document.querySelectorAll('.donateBtn');
if (donateBtns) {
  donateBtns.forEach(function(btn) {
    btn.addEventListener('click', function () {
      const optionDonate = this.closest('.custom_option_donate');
      if(optionDonate){
        const donateAmmount = optionDonate.querySelector('input').value;
        const number = Number(donateAmmount);
        if (donateAmmount.trim() === "") {
            alert('Please enter an amount');
        } else if (!isNaN(number)) {
            document.querySelector('.pre_loader').style.display = 'block';
            const ProductTitle = document.querySelector('.product__title .h1').innerText.trim();
            const formData = new FormData();
            formData.append('donateAmmount', number);
            formData.append('Title', ProductTitle);
            fetch('https://dev.shopifyexperthelp.com/app/Orrefors/create_variant.php', {
                method: 'POST',
                body: formData,
            }).then(response => response.json())
              .then(data => {
                addToCart(data);
              })
        }
      }
    });
  });
}
  
function addToCart(cartdata) {
  console.log(cartdata);
  const variantId = cartdata.varaintId;
  const sellingPlanId = cartdata.sellingplnId;
  
  if (variantId && sellingPlanId) {
    const lineItem = {
      id: variantId,
      quantity: 1,
      selling_plan: sellingPlanId
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(lineItem)
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = '/checkout';
    })
  } else {
    console.log('erroer');
    //location.reload();
  }
}



});